import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';

type Props = {
  staffs: IStaffItemData[];
  max?: number;
};

/**
 * Chips chỉ để xem — không có nút gỡ riêng. Chips nằm bên trong ô search giả
 * nên click vào là mở picker, bỏ chọn ngay trong đó rồi bấm OK.
 */
const SelectedStaffChips = ({ staffs, max = 3 }: Props) => {
  if (!staffs.length) return null;

  const visible = staffs.slice(0, max);
  const restCount = staffs.length - visible.length;

  return (
    <Container className='staff-chips'>
      {visible.map((o) => (
        <Chip key={o.id}>
          <Avatar
            src={o.urlImage || undefined}
            size={32}
            icon={<UserOutlined />}
            shape='circle'
          />
          <span className='name'>{o.firstName}</span>
        </Chip>
      ))}
      {restCount > 0 && <Chip className='rest'>{`+${restCount}`}</Chip>}
    </Container>
  );
};

export default SelectedStaffChips;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
`;

const Chip = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px 2px 2px;
  border-radius: 100px;
  border: 2px solid #2d6772;
  background: #fff;

  .name {
    max-width: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #1d2129;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
  }

  &.rest {
    padding: 6px 12px;
    color: #2d6772;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
  }
`;
